import strings from "../locales/strings";

const formatDate = (endDate) => {
  const date = new Date(endDate);

  return `${date.getDate()}\xa0${strings.shortMonths[date.getMonth()]}\xa0${
    new Date().getFullYear() !== date.getFullYear()
      ? `${date.getFullYear()}\u00A0`
      : ""
  }`;
};

export default formatDate;
